module.exports = __webpack_public_path__ + "assets/img/42@3x.88dc101d.png";